import { styled } from '@spazious/react-styles';

export type DurationSelectorCustomInputProps = React.HTMLAttributes<HTMLInputElement>;

export const DurationSelectorCustomInput = styled.input`
  width: 40px;
  border: none;
  text-align: center;
  font-size: 1.5rem;
  font-weight: 500;
  padding: 0;
  margin: 0;
  outline: none;
  background-color: transparent;
  border-top: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  padding: 8px 0;
  margin: 6px 0;
  color: var(--primary-text);
  &:disabled {
    color: var(--secondary-text);
    cursor: not-allowed;
  }
`;

export default DurationSelectorCustomInput;
